import { SwiperProps, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.css';
import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useRef, useState } from "react";
import Swiper from "swiper";
import { register } from 'swiper/element/bundle';
import Container from "../Grid/Container";
import Row from "../Grid/Row";
import Column from "../Grid/Column";
import { Link } from "@inertiajs/react";
register();

export default function GridGallery({ sources, button = null }: {
    sources: string[], button?:
        {
            link: string,
            text: string
        } | null
}) {
    const getFormat = (filename: string) => {
        return filename.split('.').pop() || 'jpeg';
    };

    const transformImage = (source: string) => {
        if(!source) return null;
        
        const baseName = source.replace(/\.[^.]+$/, '');
        const format = getFormat(source);

        return {
            webp: `${baseName}.webp`,
            original: `${baseName}.${format}`,
            format,
        };
    };

    const [realIndex, setRealIndex] = useState(1);
    const swiperRef = useRef() as any;

    useEffect(() => {
        const swiperContainer = swiperRef.current;

        if (!swiperContainer) return;

        const params: SwiperProps = {
            speed: 750,
            autoplay: {
                delay: 8000,
            },
            navigation: {
                prevEl: '.grid-gallery-prev',
                nextEl: '.grid-gallery-next',
            },
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            on: {
                realIndexChange: (swiper: Swiper) => {
                    setRealIndex(swiper.realIndex + 1);
                },
            },
        };

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, [swiperRef])

    return (
        <section className="mb-26">
            <swiper-container ref={swiperRef} init={false} navigation>
                {Array.from({ length: Math.ceil(sources.length / 4) }).map((_, slideIndex) => (
                    <swiper-slide key={slideIndex}>
                        <div className="grid grid-cols-12 gap-x-6 2xl:h-[730px] lg:h-[550px] h-[400px]">
                            <div className="lg:col-span-4 col-span-6 2xl:h-[730px] lg:h-[550px] h-[400px] grid grid-cols-1 grid-rows-2 gap-6">
                                <img
                                    src={transformImage(sources[slideIndex * 4])?.webp || ''}
                                    className="w-full h-full object-cover mb-6"
                                    alt="Zdjęcie"
                                    width={624}
                                    height={353}
                                />
                                <img
                                    src={transformImage(sources[slideIndex * 4 + 1])?.webp || ''}
                                    className="w-full h-full object-cover mb-6"
                                    alt="Zdjęcie"
                                    width={624}
                                    height={353}
                                />
                            </div>
                            <div className="lg:col-span-5 col-span-6 lg:h-auto h-[400px] maxLg:grid maxLg:grid-cols-1 maxLg:grid-rows-2 maxLg:gap-6 relative">
                                <img
                                    src={transformImage(sources[slideIndex * 4 + 2])?.webp || ''}
                                    className="w-full h-full object-cover mb-6 lg:block hidden"
                                    alt="Zdjęcie"
                                />
                                <img
                                    src={transformImage(sources[slideIndex * 4 + 2])?.webp || ''}
                                    className="w-full h-full object-cover mb-6 lg:hidden block"
                                    alt="Zdjęcie"
                                    width={786}
                                    height={730}
                                />
                                <img
                                    src={transformImage(sources[slideIndex * 4 + 3])?.webp || ''}
                                    className="w-full h-full object-cover mb-6 lg:hidden"
                                    alt="Zdjęcie"
                                    width={462}
                                    height={750}
                                />
                            </div>
                            <div className="col-span-3 lg:block hidden relative">
                                <img
                                    src={transformImage(sources[slideIndex * 4 + 3])?.webp || ''}
                                    className="w-full h-full object-cover mb-6"
                                    alt="Zdjęcie"
                                />
                            </div>
                        </div>
                    </swiper-slide>
                ))}
            </swiper-container>

            <Container>
                <Row className="justify-between items-center mt-8">
                    <Column xl={3} lg={5}>
                        <div className="flex items-center gap-x-6">
                            <button type="button" className="grid-gallery-prev glass-style py-3 px-6 rounded-[60px]">
                                <Icon icon={`solar:alt-arrow-down-outline`} width={24} className="rotate-90" />
                            </button>
                            <div className="text-i-black tracking-[0.192px] font-semibold">
                                <div className="flex gap-x-6">
                                    {Array.from({ length: Math.ceil(sources.length / 4) }).map((_, i) => (
                                        <div className={`size-3 block rounded-full ${i+1 === realIndex ? 'bg-primary' : 'bg-secondary'} `}></div>
                                    ))}
                                </div>
                            </div>
                            <button type="button" className="grid-gallery-next glass-style py-3 px-6 rounded-[60px]">
                                <Icon icon={`solar:alt-arrow-down-outline`} width={24} className="-rotate-90"/>
                            </button>
                        </div>
                    </Column>
                </Row>
            </Container>
        </section>
    )
}